import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../services/contexts/AuthContext';

const ProtectedRoute = ({ children, roles = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role-based access control
  if (roles && !roles.includes(user.role)) {
    // Redirect to appropriate dashboard based on user role
    const roleRoutes = {
      'SYSTEM_ADMIN': '/sysadmin',
      'tenant_admin': '/tenant-admin',
      'tenant_doctor': '/tenant-doctor',
      'tenant_nurse': '/tenant-nurse',
      'tenant_technician': '/tenant-technician',
      'tenant_patient': '/tenant-patient'
    };
    
    const redirectRoute = roleRoutes[user.role] || '/dashboard';
    return <Navigate to={redirectRoute} replace />;
  }

  // For legacy dashboard route, redirect to appropriate persona route
  if (location.pathname === '/dashboard' || location.pathname === '/') {
    const roleRoutes = {
      'SYSTEM_ADMIN': '/sysadmin',
      'tenant_admin': '/tenant-admin',
      'tenant_doctor': '/tenant-doctor',
      'tenant_nurse': '/tenant-nurse',
      'tenant_technician': '/tenant-technician',
      'tenant_patient': '/tenant-patient'
    };
    
    const redirectRoute = roleRoutes[user.role];
    if (redirectRoute) {
      return <Navigate to={redirectRoute} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;